(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayonae-launch-orb"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ayonae-launch')) {
    customElements.define('ayonae-launch', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.ay-launch__pause');
        this.onPause = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        };
        this.button.addEventListener('click', this.onPause);
        const raw = this.dataset.date.trim();
        const target = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
        if (!Number.isFinite(target)) return;
        const clock = this.querySelector('.ay-launch__clock');
        const status = this.querySelector('.ay-launch__status');
        const tick = () => {
          const coupon = this.querySelector('.ay-launch__coupon');
          if (coupon) coupon.hidden = !Number.isFinite(Date.parse(coupon.dataset.couponEnd)) || Date.parse(coupon.dataset.couponEnd) <= Date.now();
          const remaining = Math.max(0, Math.ceil((target - Date.now()) / 1000));
          clock.hidden = remaining === 0;
          status.hidden = remaining > 0;
          if (!remaining) {
            status.textContent = this.dataset.finished;
            clearInterval(this.timer);
            return;
          }
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [key, value] of Object.entries(values)) this.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0');
        };
        this.timer = setInterval(tick, 1000);
        tick();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.button?.removeEventListener('click', this.onPause);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayonae-social-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ayonae-social-shop')) {
    customElements.define('ayonae-social-shop', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.players = [];
        this.querySelectorAll('.ay-social__card').forEach(card => {
          const media = card.querySelector('.ay-social__media');
          const video = media.querySelector('video');
          const button = card.querySelector('button');
          let frame = null;
          let id = null;
          try {
            const url = new URL(media.dataset.tiktok);
            if (url.protocol === 'https:' && ['www.tiktok.com', 'tiktok.com'].includes(url.hostname)) id = url.pathname.match(/^\/@[^/]+\/video\/(\d+)\/?$/)?.[1];
          } catch {}
          if (!video && id) {
            frame = document.createElement('iframe');
            frame.src = 'https://www.tiktok.com/player/v1/' + id + '?autoplay=0&loop=1&muted=1&controls=0&description=0&music_info=0&rel=0';
            frame.title = 'TikTok';
            frame.allow = 'autoplay; fullscreen';
            frame.loading = 'lazy';
            media.append(frame);
          }
          if (!video && !frame) return;
          button.hidden = false;
          const state = { card, video, frame, wanted: !reduced, visible: false, ready: !!video, playing: false };
          const label = playing => {
            state.playing = playing;
            button.textContent = playing ? 'Ⅱ' : '▶';
            button.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
          };
          state.update = () => {
            const play = state.wanted && state.visible && !document.hidden;
            if (video) {
              video.muted = true;
              if (play) video.play().catch(() => label(false));
              else video.pause();
            } else if (state.ready) {
              frame.contentWindow?.postMessage({ type: play ? 'play' : 'pause', value: undefined, 'x-tiktok-player': true }, 'https://www.tiktok.com');
            }
          };
          button.addEventListener('click', () => { state.wanted = !state.playing; state.update(); }, { signal });
          if (video) {
            video.addEventListener('play', () => label(true), { signal });
            video.addEventListener('pause', () => label(false), { signal });
          } else {
            window.addEventListener('message', event => {
              if (event.origin !== 'https://www.tiktok.com' || event.source !== frame.contentWindow || !event.data?.['x-tiktok-player']) return;
              if (event.data.type === 'onPlayerReady') { state.ready = true; state.update(); }
              if (event.data.type === 'onStateChange') label(event.data.value === 1);
              if (event.data.type === 'onPlayerError') label(false);
            }, { signal });
          }
          this.players.push(state);
        });
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          const player = this.players.find(p => p.card === entry.target);
          player.visible = entry.isIntersecting;
          player.update();
        }), { threshold: .2 });
        this.players.forEach(player => this.observer.observe(player.card));
        document.addEventListener('visibilitychange', () => this.players.forEach(p => p.update()), { signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.players?.forEach(p => p.video?.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
